import { Link } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext'

export default function Landing() {
  const { t } = useLanguage()
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Nav bar */}
      <nav style={{
        background: '#fff',
        borderBottom: '1px solid var(--card-border)',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/integolf-logo.svg" alt="InteGolf" style={{ height: 36 }} />
        </Link>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="/login" style={{ color: 'var(--secondary-800)', fontWeight: 600, fontSize: 14 }}>{t('sp_sign_in', 'Sign in')}</Link>
          <Link to="/signup" className="btn btn-primary" style={{ padding: '10px 20px', fontSize: 14 }}>
            {t('sp_get_started_caps', 'Get Started')}
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #153230 0%, #005546 50%, #006753 100%)',
        color: '#fff',
        padding: '100px 20px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Decorative circles */}
        <div style={{
          position: 'absolute', top: -100, right: -100, width: 400, height: 400,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,209,159,0.15) 0%, transparent 70%)',
        }} />
        <div style={{
          position: 'absolute', bottom: -150, left: -150, width: 500, height: 500,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(27,225,177,0.1) 0%, transparent 70%)',
        }} />

        <div style={{ maxWidth: 900, margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-block',
            padding: '6px 16px',
            background: 'rgba(0, 209, 159, 0.15)',
            border: '1px solid rgba(0, 209, 159, 0.3)',
            borderRadius: 20,
            fontSize: 12,
            letterSpacing: 1.5,
            color: '#63f2c6',
            fontWeight: 700,
            marginBottom: 20,
          }}>
            {t('sp_integolf_play_and_stay_portal_caps', 'INTEGOLF PLAY AND STAY PORTAL')}
          </div>
          <h1 style={{ fontSize: 54, fontWeight: 800, margin: '0 0 20px', lineHeight: 1.05, letterSpacing: '-0.02em' }}>
            {t('sp_landing_h1', 'Launch golf + hotel packages in minutes')}
          </h1>
          <p style={{ fontSize: 19, color: 'rgba(255,255,255,0.75)', maxWidth: 680, margin: '0 auto 36px', lineHeight: 1.6 }}>
            {t('sp_landing_subhead', 'Connect your tee sheet, design a branded booking widget, and paste one line of code onto your website. Start taking bookings the same day.')}
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/signup" className="btn btn-primary" style={{ padding: '16px 36px', fontSize: 16 }}>
              {t('sp_get_started_free', 'Get Started Free')}
            </Link>
            <Link to="/login" className="btn btn-outline" style={{ padding: '16px 36px', fontSize: 16 }}>
              {t('sp_sign_in', 'Sign In')}
            </Link>
          </div>
          <div style={{ marginTop: 40, display: 'flex', gap: 32, justifyContent: 'center', flexWrap: 'wrap', color: 'rgba(255,255,255,0.6)', fontSize: 13 }}>
            <div><strong style={{ color: '#fff', fontSize: 22, display: 'block' }}>5,000+</strong> {t('sp_golfers_lower', 'golfers')}</div>
            <div><strong style={{ color: '#fff', fontSize: 22, display: 'block' }}>500+</strong> {t('sp_courses_lower', 'courses')}</div>
            <div><strong style={{ color: '#fff', fontSize: 22, display: 'block' }}>50+</strong> {t('sp_destinations_lower', 'destinations')}</div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '100px 20px', background: '#fff' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <div style={{ fontSize: 12, letterSpacing: 2, color: 'var(--brand-600)', fontWeight: 700, marginBottom: 12 }}>
              {t('sp_everything_you_need_caps', 'EVERYTHING YOU NEED')}
            </div>
            <h2 style={{ fontSize: 36, margin: '0 0 12px', color: 'var(--secondary-950)' }}>
              {t('sp_nothing_you_dont', 'Nothing you don\'t')}
            </h2>
            <p style={{ color: 'var(--text-muted)', fontSize: 16, maxWidth: 600, margin: '0 auto' }}>
              {t('sp_simple_portal_subtitle', 'A simple portal focused on one thing: selling Stay and Play packages on your website.')}
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
            <Feature
              icon={<IconGolf />}
              title={t('sp_feature_tee_sheet_title', 'Your Tee Sheet, Your Rates')}
              desc={t('sp_feature_tee_sheet_desc', 'Connect InteGolf\'s built-in tee sheet, Tee-On, ChronoGolf, TTC, or Club Prophet. We pull your available times and rates automatically.')}
            />
            <Feature
              icon={<IconHotel />}
              title={t('sp_feature_hotel_title', 'Real Hotel Pricing')}
              desc={t('sp_feature_hotel_desc', 'We search Expedia and partner hotels near your course and show live rates with your package.')}
            />
            <Feature
              icon={<IconBrush />}
              title={t('sp_feature_brand_title', 'Match Your Brand')}
              desc={t('sp_feature_brand_desc', 'Upload your logo, pick your colors and fonts, choose from 5 widget layouts, and preview it live.')}
            />
            <Feature
              icon={<IconPackage />}
              title={t('sp_feature_packages_title', 'Build Packages Your Way')}
              desc={t('sp_feature_packages_desc', 'Create Basic, Executive, and Premium tiers with different hotel budgets, tee time windows, and inclusions.')}
            />
            <Feature
              icon={<IconCode />}
              title={t('sp_feature_install_title', 'One-Line Install')}
              desc={t('sp_feature_install_desc', 'Copy an iframe snippet, paste it on your website. Works with WordPress, Squarespace, Wix, or raw HTML.')}
            />
            <Feature
              icon={<IconChart />}
              title={t('sp_feature_track_title', 'Track Everything')}
              desc={t('sp_feature_track_desc', 'Dashboard shows sales, pending payouts, and recent bookings. You get paid, we handle the rest.')}
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, var(--brand-50) 0%, var(--brand-100) 100%)',
        textAlign: 'center',
      }}>
        <h2 style={{ fontSize: 34, margin: '0 0 12px', color: 'var(--secondary-950)' }}>
          {t('sp_ready_to_get_started', 'Ready to get started?')}
        </h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: 28, fontSize: 16 }}>
          {t('sp_landing_pricing_blurb', 'Free to sign up. 5% commission only on completed bookings.')}
        </p>
        <Link to="/signup" className="btn btn-dark" style={{ padding: '16px 40px', fontSize: 16 }}>
          {t('sp_create_your_portal_btn', 'Create Your Portal')}
        </Link>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '32px 24px',
        background: 'var(--secondary-950)',
        color: 'rgba(255,255,255,0.7)',
      }}>
        <div style={{
          maxWidth: 1100, margin: '0 auto',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16,
        }}>
          <img src="/integolf-logo-white.svg" alt="InteGolf" style={{ height: 28 }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, fontSize: 13, flexWrap: 'wrap' }}>
            <Link to="/terms" style={{ color: 'rgba(255,255,255,0.7)' }}>{t('sp_terms_of_use', 'Terms of Use')}</Link>
            <span>&copy; {new Date().getFullYear()} InteGolf &middot; {t('sp_play_and_stay_portal', 'Stay and Play Portal')}</span>
          </div>
        </div>
      </footer>
    </div>
  )
}

function Feature({ icon, title, desc }) {
  return (
    <div className="card" style={{
      padding: 28,
      transition: 'transform 0.2s, box-shadow 0.2s',
    }}>
      <div style={{
        width: 52, height: 52, borderRadius: 12,
        background: 'linear-gradient(135deg, var(--brand-50), var(--brand-100))',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'var(--brand-600)', marginBottom: 16,
      }}>
        {icon}
      </div>
      <h3 style={{ margin: '0 0 8px', fontSize: 18, color: 'var(--secondary-950)' }}>{title}</h3>
      <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.6 }}>{desc}</p>
    </div>
  )
}

// Brand-colored icons
function IconGolf() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 18V6" /><path d="M8 18h8" /><circle cx="12" cy="4" r="2" />
    </svg>
  )
}
function IconHotel() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21V8l9-5 9 5v13" /><path d="M9 21v-6h6v6" /><path d="M9 12h.01M15 12h.01" />
    </svg>
  )
}
function IconBrush() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.06 11.9l8.07-8.06a2.85 2.85 0 114.03 4.03l-8.06 8.08" />
      <path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 00-3-3.02z" />
    </svg>
  )
}
function IconPackage() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.5 9.4L7.55 4.24" /><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" /><path d="M3.27 6.96L12 12.01l8.73-5.05" /><path d="M12 22.08V12" />
    </svg>
  )
}
function IconCode() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
    </svg>
  )
}
function IconChart() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  )
}
